// Dependencies
var _ = require('underscore');
var Backbone = require('backbone');
var Radio = require('backbone.radio');
var EntitiesAPI = require('app/utils/entities').EntitiesAPI;

// App
var DeferEntity = require('app/utils/defer-entity');

// Channels
var channel = Radio.channel('global');

var Config = Backbone.Model.extend({
    url: '/public/config.json',
});

var config = new DeferEntity(Config);

var ConfigAPI = EntitiesAPI.extend({
    radioPrefix: false,
    channel: channel,
    replyConfig: function(options) {
        options = options || {};
        _.defaults(options, { returnInstance: false });
        return config.defer(options);
    },
    replyConfigPick: function(pick) {
        if (!pick) {
            return undefined;
        }
        var instance = config.defer({ returnInstance: true });
        return instance.get(pick);
    },
});

module.exports = {
    Config: Config,
    API: ConfigAPI,
};
